import React, { useState } from "react";
import "../../css/pages/services.css";
import SeeMoreButton from "../designSystem/buttons/SeeMoreButton";
import imageOne from "../../assets/images/Protection2.jpg";
import imageTwo from "../../assets/images/Protection3.jpg";
import imageThree from "../../assets/images/Protection4.jpg";
import imageFour from "../../assets/images/Protection5.jpg";
import imageFive from "../../assets/images/Protection6.jpg";
import Hero from "../designSystem/Hero";
import HeroImage from "../../assets/images/Protection1.jpg";
import ContactUsPage from "./ContactUsPage";

const protectionData = [
  {
    title: "Protection",
    subtitle: "Protecting What Matters Most",
    description:
      "Financial protection provides security for you and your loved ones when it is needed most. We help you put plans in place to safeguard your income, home and lifestyle, ensuring that unexpected events do not disrupt your long term financial wellbeing.",
    image: imageOne,
  },
  {
    title: "Protection",
    subtitle: "Life Cover",
    description:
      "Life insurance can provide vital financial support to your family if the worst happens. We help you choose the right level of cover so that your loved ones are protected, whether that means paying off a mortgage, covering living costs or maintaining their quality of life.",
    image: imageTwo,
  },
  {
    title: "Protection",
    subtitle: "Income Protection",
    description:
      "Your ability to earn an income is one of your most valuable assets. Income protection can provide a regular income if you are unable to work due to illness or injury, helping you meet your financial commitments and maintain stability during difficult times.",
    image: imageThree,
  },
  {
    title: "Protection",
    subtitle: "Critical Illness Cover",
    description:
      "A serious illness can have a significant financial impact as well as an emotional one. Critical illness cover provides a lump sum payment on diagnosis of specified conditions, giving you the financial flexibility to focus on recovery without added financial pressure.",
    image: imageFour,
  },
  {
    title: "Protection",
    subtitle: "Business Protection",
    description:
      "Providing your business with a financial safety net when it matters most. Our Business Protection solutions cover Key Person Insurance, Shareholder Protection, Business Loan Protection, and Relevant Life, helping maintain control, continuity, and financial stability if a key individual dies or becomes incapacitated.",
    image: imageFive,
  },
];

const ProtectionPage = () => {
  // State to track which descriptions are shown
  const [showDescriptions, setShowDescriptions] = useState(
    protectionData.map(() => true),
  );

  // Handler to toggle description visibility for a card
  const handleSeeMoreClick = (idx) => {
    setShowDescriptions((prev) =>
      prev.map((shown, i) => (i === idx ? !shown : shown)),
    );
  };

  return (
    <div className="home-page about-page">
      <Hero
        title="Helping you protect what matters most"
        subtitle="Protection"
        primary={true}
        backgroundImage={HeroImage}
        titleAlign="center"
        subtitleAlign="center"
      />

      <section className="page-section">
        <div className="page-section-inner">
          <div className="page-card-grid">
            {protectionData.map((protection, index) => (
              <div className="page-card" key={index}>
                <div className="page-card-image">
                  <img src={protection.image} alt={protection.title} />
                </div>

                <div className="page-card-content">
                  <div className="nav primary">{protection.title}</div>
                  <h2 className="primary">
                    {protection.subtitle.split(" ")[0]}{" "}
                    <span className="italic-text">
                      {protection.subtitle.split(" ")[1]}{" "}
                      {protection.subtitle.split(" ")[2]}{" "}
                      {protection.subtitle.split(" ")[3]}
                    </span>
                  </h2>
                  {showDescriptions[index] && (
                    <div className="content primary">
                      {protection.description}
                    </div>
                  )}

                  <SeeMoreButton onClick={() => handleSeeMoreClick(index)}>
                    {showDescriptions[index] ? "See Less" : "See More"}
                  </SeeMoreButton>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="investment-note-section">
        <div className="home-container investment-note body">
          {/* <strong>Please Note:</strong> The value of protection products and the
          income they produce can fall as well as rise. You may get back less
          than you invested. Transferring out of a final salary pension is
          unlikely to be in the best interests of most people. */}
        </div>
      </section>
      <ContactUsPage />
    </div>
  );
};

export default ProtectionPage;
